import React, { useMemo } from "react";

interface Props {
  firstName: string;
  lastName: string;
  hasStatus?: boolean;
  size?: number;
}

export const ProfileBadge: React.FC<Props> = ({
  firstName,
  lastName,
  hasStatus,
  size,
}) => {
  const initials = useMemo(() => {
    try {
      return firstName[0].toUpperCase() + lastName[0].toUpperCase();
    } catch (error) {
      return "";
    }
  }, [firstName, lastName]);

  return (
    <div className="relative">
      <div
        className="relative z-[1] w-[32px] h-[32px] flex flex-row justify-center items-center rounded-full bg-blue"
        style={{ width: size, height: size }}
      >
        <h3 className="text-white font-medium text-lg">{initials}</h3>
      </div>
      {hasStatus && (
        <div className="absolute z-[2] bottom-0 right-0 rounded-full border-[2px] border-white bg-green-dark w-[10px] h-[10px]" />
      )}
    </div>
  );
};

ProfileBadge.defaultProps = {
  hasStatus: false,
  size: 32,
};
